module.exports = __webpack_public_path__ + "static/media/upload-lead.2537a182.svg";